import { useMutation } from "@tanstack/react-query"
import axios from "axios";
import { SustainabilityJobClient, SustainabilitySyncResponse } from "./apiClient";

const sustainabilityJobClient = new SustainabilityJobClient(undefined, axios);

export const useRunSustainabilitySyncJob = (options?: any) => {
    return useMutation<SustainabilitySyncResponse, Error, void>({
        mutationFn: () =>
            sustainabilityJobClient.syncSustainabilityData(),
        ...options,
    });
};